import secureApi from "../services/secureApi";
/* ---------- COMMON ERROR HANDLER ---------- */
const handleApiError = (error) => {
  if (error?.response?.status === 422) {
    const customError = new Error(
      error.response.data?.message || "Validation Error",
    );
    customError.status = 422;
    customError.errors = error.response.data?.errors || {};
    throw customError;
  }
  const generalError = new Error(
    error.response?.data?.message || error.message || "Something went wrong",
  );
  throw generalError;
};
/* ---------- LIST ---------- */
export const getPostTemplatesApi = async ({ page = 1, pageSize = 9 }) => {
  try {
    const payload = {
      page,
      limit: pageSize,
    };
    const response = await secureApi.post(
      `/admin/banners/list`,
      payload,
    );
    return response.data; 
  } catch (error) {
    handleApiError(error);
  }
};
/* ---------- ADD NEW ---------- */
export const addPostTemplateApi = async (payload) => {
  try {
    const response = await secureApi.post(
      `/admin-upload/banners/add`,
      payload
    );
    return response.data;   
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
/* ---------- EDIT ---------- */
export const updatePostTemplateApi = async (id, payload) => {
  try {
    const response = await secureApi.put(
      `/admin-upload/banners/edit`,   
      {
        bannerId: id,
        ...payload,
      }
    );
    return response.data;   
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
/* ---------- GET ONE BY ID ---------- */
export const getPostTemplateByIdApi = async (id) => {
  try {
    const response = await secureApi.get(
      `/admin/banners/view/${id}`
    );
    return response.data;  
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};